module.exports = __webpack_public_path__ + "assets1662726319812/img/logo-block.b2a020b6.png";